import { State, Action } from './types';

export const getInitialState = () => ({
  activeTeachingOrderIndex: 0,
  previousActiveIndex: 0,
  hasUnsavedChanges: false,
  activeTeachingOrder: { name: 'Teaching Order' },
  activeCharacters: new Array(26),
  isActiveTeachingOrderDisplayed: true,
  isSaving: false,
  resetSignal: 0,
  [0]: {
    __typename: null,
    id: 0,
    name: '',
    characters: [],
    selectedChar: null,
    arrow: null,
  },
});

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'SET_UNSAVED_CHANGES':
      return {
        ...state,
        ...action.payload,
      };
    case 'SET_IS_SAVING':
      return {
        ...state,
        isSaving: action.payload.isSaving,
      };
    case 'SET_TEACHING_ORDERS':
      return {
        ...state,
        ...action.payload,
        hasUnsavedChanges: false,
      };
    case 'SET_SELECTED_CHAR':
      return {
        ...state,
        ...action.payload,
      };
    case 'UPDATE_ACTIVE_INDEX':
      return {
        ...state,
        activeTeachingOrderIndex: action.payload.activeTeachingOrderIndex,
        previousActiveIndex: action.payload.previousActiveIndex,
        hasUnsavedChanges: false,
      };
    case 'UPDATE_TEACHING_ORDER':
      return {
        ...state,
        ...action.payload,
      };
    case 'BUMP_RESET_SIGNAL':
      return {
        ...state,
        resetSignal: state.resetSignal + 1,
      };
    default:
      return getInitialState();
  }
};
